import React from 'react';
import { Container } from '@groupelacentrale/contact-storybook';
import { Link } from 'react-router-dom';
import { LoginForm } from 'components';
import { usePageTracking } from 'hooks';
import { ROUTES } from 'routes';
import './AuthPage.scss';
import { TRACKING_PAGES } from 'api';

export const LoginPage = (): React.ReactElement => {
  usePageTracking(TRACKING_PAGES.CONNEXION);

  return (
    <Container shadowed paddings="mediumP" backgroundColor="bgWhite">
      <LoginForm />
      <p className="text-center">
        <Link to={ROUTES.resetPassword}>Mot de passe oublié ?</Link>
      </p>
      <p className="login-register-link">
        <span>
          <strong>Vous n&apos;avez pas de compte ?</strong>
        </span>
        &nbsp;
        <Link to={ROUTES.register}>Inscription</Link>
      </p>
    </Container>
  );
};
